// NavbarProductsButton.jsx
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Stack, Paper } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { LinkButton } from '../../../components/buttons';
import NavbarProductsMenu from './NavbarProductsMenu';
import useNavbarProducts from '../../../hooks/useNavbarProducts';

const NavbarProductsButton = ({ url, variant, ...rest }) => {
  const navigate = useNavigate();
  const options = useNavbarProducts();
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef(null);
  const show = () => { clearTimeout(timeoutRef.current); setOpen(true); };
  const hide = () => { timeoutRef.current = setTimeout(() => setOpen(false), 200); };

  return (
    <Stack onMouseOver={show} onMouseLeave={hide} onFocus={show}>
      <LinkButton
        url={url}
        title="Nuestros servicios"
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        onClick={() => navigate(url)}
        variant={variant}
        {...rest}
      />
      {open && (
        <Paper sx={{ position: 'absolute', mt: '3.3rem' }}>
          <NavbarProductsMenu
            options={options}
            onSelect={(to) => navigate(to)}
            variant="navbarProductsItem"
          />
        </Paper>
      )}
    </Stack>
  );
};

NavbarProductsButton.propTypes = {
  url: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
};

export default NavbarProductsButton;
